import {DashboardCard} from '../dashboard-card/DashboardCard'
import {useTranslation} from '@/translations/i18n'
import {Text} from '@/components/ui/text/Text'
import {formatCurrency} from '@/utilities/helpers'
import {useGetDashboardAnalytics} from '../../query/useGetDashboardAnalytics'
import {DashboardEconomicSearchParams} from '../../types'
import {useParsedSearchParams} from '@/hooks/useParsedSearchParams'
import {DashboardSimpleCardSkeleton} from '../dashboard-simple-card-skeleton/DashboardSimpleCardSkeleton'

export const DashboardOtherCostsCard = () => {
    const {t} = useTranslation()
    const {searchParams} = useParsedSearchParams(DashboardEconomicSearchParams)
    const {data, isLoading} = useGetDashboardAnalytics({
        fields: ['billedAccesses', 'costs', 'otherCosts'],
        ...searchParams
    })

    if (isLoading) {
        return <DashboardSimpleCardSkeleton title={t('dashboard:other_costs')} />
    }

    return (
        <DashboardCard title={t('dashboard:other_costs')}>
            <Text palette="neutral" shade="900" size="textXl" weight={700}>
                {formatCurrency(data?.otherCosts?.total ?? 0)}
            </Text>
        </DashboardCard>
    )
}
